export const GET_NOTACLINICA = "GET_NOTACLINICA";
export const NEW_NOTACLINICA = "NEW_NOTACLINICA";
export const SET_NOTACLINICA = "SET_NOTACLINICA";
export const SAVE_NOTACLINICA_REQUEST = "SAVE_NOTACLINICA_REQUEST";
export const SAVE_NOTACLINICA_SUCCESS = "SAVE_NOTACLINICA_SUCCESS";
export const SAVE_NOTACLINICA_FAILURE = "SAVE_NOTACLINICA_FAILURE";
